import { render } from "./LogoWhite.vue?vue&type=template&id=0777fa77"
const script = {}

import exportComponent from "/home/gavin/dev/sumfo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__